import { 
    HOMOLOGOUS_PROCEDURE_BEGIN,
    HOMOLOGOUS_PROCEDURE_SUCCESS,
    HOMOLOGOUS_PROCEDURE_FAILURE,
    HOMOLOGOUS_PROCEDURE_CLEAR,

    HOMOLOGOUS_PROCEDURE_FILTER_BEGIN,
    HOMOLOGOUS_PROCEDURE_FILTER_SUCCESS,
    HOMOLOGOUS_PROCEDURE_FILTER_FAILURE,
    HOMOLOGOUS_PROCEDURE_FILTER_CLEAR

} from 'app/actions/HomologousProcedureActions';

const initialState = {
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function HomologousProcedureReducer (state = initialState, action) {
	switch (action.type) {
        case HOMOLOGOUS_PROCEDURE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case HOMOLOGOUS_PROCEDURE_SUCCESS:
            let allIds = action.payload.data.Data;
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case HOMOLOGOUS_PROCEDURE_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case HOMOLOGOUS_PROCEDURE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case HOMOLOGOUS_PROCEDURE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case HOMOLOGOUS_PROCEDURE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case HOMOLOGOUS_PROCEDURE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case HOMOLOGOUS_PROCEDURE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getHomologousProcedure = state => {
	return state.allIds;
}

export const getIsLoadingHomologousProcedure = state => {
    return state.isLoading;
}

export const getHomologousProcedureFilter = state => {
    return state.filterData
}
export const getIsLoadingHomologousProcedureFilter = state => {
    return state.isLoading;
}